<template>
  <v-container fill-height>
    <v-row>
      <v-col md=3>
        <div>
          <div class="rating_label"> {{ calculateRatingAverage }} </div>
          <v-rating v-model="calculateRatingAverage" readonly dense half-increments :size=26 color="white"></v-rating>
        </div>
      </v-col>
      <v-col md=9>
        <feedback-rating-component />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import FeedbackRatingComponent from "./FeedbackRatingComponent"

  export default {
    name: "FeedbackDashboard",
    components: {
      FeedbackRatingComponent
    },
    props: {
      valuesList: {
        default:() => [
          ],
        type: Array,
        required: false
      },
    },
    data() {
      return {
        RatingData: {
          orders: 231,
          ratings: 175,
          comments: 83,
          overall_rateing: 4.5,
          last_comments: [
            {
              rate: 4,
              date: "05.05.2020",
              comment: 'Das ist ein Ratingtext. Dieser dient zum Test'
            }
          ]
        }
      }
    },
    computed: {
      RatingPerentage: function() {
        let percent = Math.round(this.RatingData.ratings / this.RatingData.orders * 100)
        return `(${percent}%)`
      },
      CommentsPercentage: function() {
        let percent =  Math.round(this.RatingData.comments / this.RatingData.orders * 100)
        return `(${percent}%)`
      },
      calculateRatingAverage() {
        let ratings = this.$store.getters.getRatings
        let sum = ratings.reduce( (prev, curr) => prev + curr.rating, 0);
        let average = sum/ratings.length
        return Math.round( average * 10 + Number.EPSILON ) / 10
      }
    }
  }
</script>

<style scoped>
.rat_margin {
    margin: 0 25px;
}
.rating_label {
    font-size: 100px;
    font-weight: bold;
}
.rating_box {
    display: flex;
    flex-direction: row;
}
.rating_col1 {
    display: flex;
    flex-direction: column;
}
.rating_col2 {
    display: flex;
    flex-direction: column;
    width: 387px;
}
.rating_col3 {
    align-content: center;
}
.single_rate {
    display: flex;
    flex-direction: row;
    align-items: baseline;
}
.rate_big_num {
    display: flex;
    flex-direction: row;
}
.single_rate_num {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: space-between;
}
.rating_em {
    font-style: italic;
    font-weight: bold;
    font-size: 38px;
}
</style>
